import { Button, Space } from "antd";

const TrustedDriverConfiguration = ({proceedLabel = 'Proceed', show, client, onBack, onNext, onClose}: any) => {

    const onFinish = () => {
        const data = {...client, source: {type: 'TD_LOCAL'}};
        onNext(data);
    }

    return <div 
        className="clients-page-form"
        style={{overflow: 'hidden', height: show ? 'auto' : '0rem'}}
        >
  
        <h2>Data will be fetched from Trusted Driver Local DB</h2>
        
        <Space direction="horizontal" align="end" style={{marginTop: '2rem', width: '100%', justifyContent: 'flex-end'}}>
            <Button type="default" key="cancel" onClick={onClose}>Cancel</Button>
            <Button type="primary" onClick={onBack}>Back</Button>
            <Button type="primary" onClick={onFinish}>{proceedLabel}</Button>
        </Space>
    </div>
  }

  export default TrustedDriverConfiguration;